$(document).ready(function(){
    $('.collection-carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.faq-trigger').on('click', function(){
        $(this).toggleClass('active');
        $(this).siblings('.faq-question-outer').find('.faq-question-inner').slideToggle();
    })

    $('.main-menu-toggle').on('click', function(){
        $(this).toggleClass('is-active');
        $('.glue-mobile-nav').slideToggle();
        $('body').toggleClass('o-y-hidden')
    })

    $('.searchToggle').on('click', function(e){
        e.preventDefault();
        $('#SearchDrawer').fadeIn();
    })

    $('.search-bar__close').on('click', function(){
        $('#SearchDrawer').fadeOut();

    })

    $('.promo-text .title').on('click', function(){
        $(this).siblings('.body').slideToggle();
    })



})




const selectVariantByClickingImage = {
    // Create variant images from productJson object
    _createVariantImage: function (product) {
        const variantImageObject = {};
        product.variants.forEach((variant) => {
            if (
                typeof variant.featured_image !== 'undefined' &&
                variant.featured_image !== null
            ) {
                const variantImage = variant.featured_image.src
                    .split('?')[0]
                    .replace(/http(s)?:/, '');
                variantImageObject[variantImage] =
                    variantImageObject[variantImage] || {};
                product.options.forEach((option, index) => {
                    const optionValue = variant.options[index];
                    const optionKey = `option-${index}`;
                    if (
                        typeof variantImageObject[variantImage][optionKey] === 'undefined'
                    ) {
                        variantImageObject[variantImage][optionKey] = optionValue;
                    } else {
                        const oldValue = variantImageObject[variantImage][optionKey];
                        if (oldValue !== null && oldValue !== optionValue) {
                            variantImageObject[variantImage][optionKey] = null;
                        }
                    }
                });
            }
        });
        return variantImageObject;
    },
    _updateVariant: function (event, id, product, variantImages) {
        const arrImage = event.target.src
            .split('?')[0]
            .replace(/http(s)?:/, '')
            .split('.');
        const strExtention = arrImage.pop();
        const strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, '');
        const strNewImage = `${arrImage.join('.')}.${strRemaining}.${strExtention}`;
        if (typeof variantImages[strNewImage] !== 'undefined') {
            product.variants.forEach((option, index) => {
                const optionValue = variantImages[strNewImage][`option-${index}`];
                if (optionValue !== null && optionValue !== undefined) {
                    const selects = document.querySelectorAll('#'+ id + ' [class*=single-option-selector]');
                    const options = selects[index].options;
                    for (let option, n = 0; (option = options[n]); n += 1) {
                        if (option.value === optionValue) {
                            selects[index].selectedIndex = n;
                            selects[index].dispatchEvent(new Event('change'));
                            break;
                        }
                    }
                }
            });
        }
    },
    _selectVariant: function() {
        const productJson = document.querySelectorAll('[id^=ProductJson-');
        if (productJson.length > 0) {
            productJson.forEach((product) => {
                const sectionId = product.id.replace("ProductJson-", "shopify-section-");
                const thumbnails = document.querySelectorAll('#'+ sectionId + ' img[src*="/products/"]');
                if (thumbnails.length > 1) {
                    const productObject = JSON.parse(product.innerHTML);
                    const variantImages = this._createVariantImage(productObject);
                    // need to check variants > 1
                    if (productObject.variants.length > 1) {
                        thumbnails.forEach((thumbnail) => {
                            thumbnail.addEventListener('click', (e) =>
                                this._updateVariant(e, sectionId, productObject, variantImages),
                            );
                        });
                    }
                }
            });
        }
    },
};
if (document.readyState !== 'loading') {
    selectVariantByClickingImage._selectVariant();
} else {
    document.addEventListener(
        'DOMContentLoaded',
        selectVariantByClickingImage._selectVariant(),
    );
}

class Accordion {
    constructor(el) {
        // Store the <details> element
        this.el = el;
        // Store the <summary> element
        this.summary = el.querySelector('summary');
        // Store the <div class="content"> element
        this.content = el.querySelector('.content');

        // Store the animation object (so we can cancel it if needed)
        this.animation = null;
        // Store if the element is closing
        this.isClosing = false;
        // Store if the element is expanding
        this.isExpanding = false;
        // Detect user clicks on the summary element
        this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
        // Stop default behaviour from the browser
        e.preventDefault();
        // Add an overflow on the <details> to avoid content overflowing
        this.el.style.overflow = 'hidden';
        // Check if the element is being closed or is already closed
        if (this.isClosing || !this.el.open) {
            this.open();
            // Check if the element is being openned or is already open
        } else if (this.isExpanding || this.el.open) {
            this.shrink();
        }
    }

    shrink() {
        // Set the element as "being closed"
        this.isClosing = true;

        // Store the current height of the element
        const startHeight = `${this.el.offsetHeight}px`;
        // Calculate the height of the summary
        const endHeight = `${this.summary.offsetHeight}px`;

        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.el.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight]
        }, {
            duration: 400,
            easing: 'ease-out'
        });

        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(false);
        // If the animation is cancelled, isClosing variable is set to false
        this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
        // Apply a fixed height on the element
        this.el.style.height = `${this.el.offsetHeight}px`;
        // Force the [open] attribute on the details element
        this.el.open = true;
        // Wait for the next frame to call the expand function
        window.requestAnimationFrame(() => this.expand());
    }

    expand() {
        // Set the element as "being expanding"
        this.isExpanding = true;
        // Get the current fixed height of the element
        const startHeight = `${this.el.offsetHeight}px`;
        // Calculate the open height of the element (summary height + content height)
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.el.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight]
        }, {
            duration: 400,
            easing: 'ease-out'
        });
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(true);
        // If the animation is cancelled, isExpanding variable is set to false
        this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
        // Set the open attribute based on the parameter
        this.el.open = open;
        // Clear the stored animation
        this.animation = null;
        // Reset isClosing & isExpanding
        this.isClosing = false;
        this.isExpanding = false;
        // Remove the overflown hidden and the fixed height
        this.el.style.height = this.el.style.overflow = '';
    }
}

console.log(document.querySelectorAll('details'));
document.querySelectorAll('details').forEach((el) => {
    console.log(el)
    new Accordion(el);
});
